<template>
  <div>
    <ContractImp
    class="contentWrapper"
    :campaignType="campaignType"
    :checkDate="checkDate"
    :clickDate="clickDate"
    :isInterPlay="isInterPlay"
    :viewData="viewData.data"
    ></ContractImp>
    <InterPlayAdBottom
    :campaignType="campaignType"
    :getViewDataList="getViewDataList"
    :campaignData="viewData.data"
    :checkDate="checkDate"
    :clickDate="clickDate"
    v-if="isInterPlay"
    :isExcel="isExcel"
    ></InterPlayAdBottom>
    <dateTable
    :campaignType="campaignType"
    :checkDate="checkDate"
    :clickDate="clickDate"
    :campaginDaysData="viewData.daysData"
    :dataInfo="viewData.data"
    tab="contract"
    v-if="!isInterPlay"
    ></dateTable>
  </div>
</template>

<script>
  import {mapState, mapMutations, mapGetters} from 'vuex'
  import {isInterPlay, checkCampaignType} from '@/assets/func'

  import ContractImp from '@/components/campaign/contract/ContractImp'
  import dateTable from '@/components/campaign/campaignBotTable/dateTable'
  import InterPlayAdBottom from '@/components/campaign/campaignBotTable/InterPlayAdBottom'

  export default {
    name: 'adMain',
    components: {
      ContractImp,
      dateTable,
      InterPlayAdBottom
    },
    data () {
      return {
        campaign: {},
        selectedDate: [],
        isExcel: false
      }
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      ...mapGetters([
        'getInterPlayDaysData'
      ]),
      checkCampaignType () { // 상품별 페이지 -> 일반상품, 인터플레이 구분
        return checkCampaignType(
          this.isInterPlay,
          this.currentCampaign.campaign_nm,
          this.contractData.contract
        )
      },
      checkDate (date) { // 캠페인 상세 -> 상품,사이즈,소재/ 일별 에서 선택여부 확인(상세 데이터 표시/숨김에 사용)
        return this.selectedDate.indexOf(date) > -1
      },
      clickDate (date) { // 선택한 날짜가 이미 있으면 제거, 없으면 리스트에 추가
        if (this.checkDate(date)) {
          this.selectedDate.splice(this.selectedDate.indexOf(date), 1)
          return
        }
        this.selectedDate.push(date)
      },
      getViewDataList (selected) {
        return this.getInterPlayDaysData()(selected)
      }
    },
    computed: {
      ...mapState({
        contractData: state => state.campaign.contractData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      campaignType () {
        return this.checkCampaignType()
      },
      isInterPlay () {
        return isInterPlay()
      },
      viewData () {
        return {
          data: this.contractData.contract,
          daysData: this.contractData.contractAndDate
        }
      }
    },
    created () {
      this.setCampaignDetailTap('contract')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AdMain.vue?64fffaea